/**
 * NU DATA brand logo + icon — ported from
 * NU-DATA-DASHBOARD/kits/_core/brand-logo.jsx (NuBrandLogo / NuBrandIcon),
 * specialized to this repo's checked-in assets under public/brand/nu-data/
 * (served from the site root by Vite). `mode` follows the kit contract:
 * the asset variant matches the ACTIVE THEME name (light theme →
 * logo-full-light.png), exactly as NuShellRail passes mode={theme}.
 */

import React from "react";

type BrandMode = "light" | "dark";

export interface NuBrandLogoProps {
  mode: BrandMode;
  width?: number;
  alt?: string;
  style?: React.CSSProperties;
}

export function NuBrandLogo({
  mode,
  width = 152,
  alt = "NU DATA",
  style,
}: NuBrandLogoProps) {
  return (
    <img
      src={`/brand/nu-data/logo-full-${mode}.png`}
      alt={alt}
      style={{ width, height: "auto", display: "block", ...style }}
    />
  );
}

export interface NuBrandIconProps {
  mode: BrandMode;
  size?: number;
  alt?: string;
  style?: React.CSSProperties;
}

export function NuBrandIcon({
  mode,
  size = 32,
  alt = "NU DATA icon",
  style,
}: NuBrandIconProps) {
  return (
    <img
      src={`/brand/nu-data/logo-icon-${mode}.png`}
      alt={alt}
      style={{ width: size, height: size, display: "block", ...style }}
    />
  );
}
